import { inject, Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class LingMatPaginatorIntl extends MatPaginatorIntl {
  translationService = inject(TranslateService);
  override previousPageLabel = this.translationService.instant(
    'paginator.previousPage'
  );
  override nextPageLabel =
    this.translationService.instant('paginator.nextPage');
  override firstPageLabel = this.translationService.instant(
    'paginator.firstPage'
  );
  override lastPageLabel =
    this.translationService.instant('paginator.lastPage');
  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    const of = this.translationService.instant('paginator.ofTotal');
    if (length === 0 || pageSize === 0) {
      return `0 ${of} ` + length;
    }

    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;
    return startIndex + 1 + ' - ' + endIndex + ` ${of} ` + length;
  };
}
